export default {
    showSuccess : function(title, message) {
        title = title !== undefined ? title : "Success";
        message = message !== undefined ? message: "Succeed";
        Swal.fire({
            icon: 'success',
            title: title,
            text: message,
        })
    },
    showError : function (title, message) {
        title = title !== undefined ? title : "Error";
        message = message !== undefined ? message: "Failed";
        Swal.fire({
            icon: 'warning',
            title: title,
            html: message,
        })
    },
    showDeleteQuestion(onConfirm){
        Swal.fire({
            title: 'Bu kaydı silmek istediğinize emin misiniz?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sil',
            denyButtonText: `Vazgeç`,
        }).then((result) => {
            if (result.isConfirmed) {
                onConfirm();
            } else if (result.isDenied) {}
        })
    },
    showQuestion(onConfirm,title){
        Swal.fire({
            title: title,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Onayla',
            denyButtonText: `Vazgeç`,
        }).then((result) => {
            if (result.isConfirmed) {
                onConfirm();
            } else if (result.isDenied) {}
        })
    }

}
